<template>
  <div>
    <div class="oss_file">
      <input type="file" :id="id" :multiple="multiple" @change="doUpload" accept="image/">
    </div>
  </div>
</template>

<script>
import { MessageBox, Indicator } from "mint-ui";
import request from "@/utils/request";
import Cookies from "js-cookie";
import global_ from "@/global.config";
export default {
  props: {
    multiple: Boolean,
    id: String,
    // len: Number,
    url: Array,
  },
  data() {
    return {
      speed: 0,//获取上传平均速率（KB/S）
      progress: 0, //获取上传进度百分比
      urls: this.url //①创建props属性url的副本--urls
    };
  },
  watch: {
    url(val) {
      this.urls = val; //②监听外部对props属性url的变更，并同步到组件内的data属性urls中
    }
  },
  methods: {
    randomString(len) { 
        len = len || 32;
        let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
        let maxPos = chars.length;
        let pwd = '';
        for (let i = 0; i < len; i++) {
            pwd += chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;            
    }, 
    doUpload() {
      const _this = this;
      if (Cookies.get("openid") && Cookies.get("passport")) {
        request
          .get(this.global.API_URL, {
            action: "/huaweiyun/HuaweiyunAction/sts"
          })
          .then(response => {
            let params = response.obj;
            let obsClient = new ObsClient({
              access_key_id: params.accessKeyId,
              secret_access_key: params.accessKeySecret,
              server: params.endpoint,
              timeout: 60*5
            });
            const files = document.getElementById(_this.id);
            if (files.files){
              let resultUpload = _this.urls;
              Indicator.open({
                text: "上传中...",
                spinnerType: "fading-circle"
              });
              const fileLen = document.getElementById(_this.id).files;
              for (let i = 0; i < fileLen.length; i++) {
                  const file = fileLen[i];
                  let suffix = file.name.split(".").pop();
                  let storeAs = `${params.dir}/${Date.parse(
                      new Date()
                    )}_${_this.randomString(32)}.${suffix}`;
                  obsClient.putObject({
                      Bucket:params.bucket,
                      Key:storeAs,
                      Metadata:{ContentType:'image/jpeg'},
                      SourceFile: file,
                      ProgressCallback: function(transferredAmount, totalAmount, totalSeconds){
                        _this.speed = transferredAmount * 1.0 / totalSeconds / 1024;
                        _this.progress = transferredAmount * 100.0 / totalAmount
                      }
                  }).then(function(result){
                    console.log(result)
                      console.log('Status-->' + result.CommonMsg.Status);
                      if(result.InterfaceResult){
                          console.log('RequestId-->' + result.InterfaceResult.RequestId);
                      }
                      let baseUrl = `${params.host}/${storeAs}`;
                      Indicator.close();
                      resultUpload.push(baseUrl);

                  }).catch(function(err){
                      MessageBox.alert(err, "提示2").then(() => {
                        Indicator.close();
                      });
                  });
              }
              _this.urls = resultUpload;
              console.log('上传成功的图片返回的地址=====》',_this.urls)
              //③组件内对urls变更后向外部发送事件通知
              _this.$emit("changeUrl", _this.urls);
            }
          });
      } else {
        MessageBox.alert("未授权用户", "提示");
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.oss_file {
  position absolute
  left 0
  right 0
  top 0
  bottom 0
}
.oss_file  input {
  right: 0
  top: 0
  opacity: 0
  // filter: alpha(opacity=0)
  cursor: pointer
  width: 100%
  height: 100%
}
</style>
